module.controller('sampleAnalyzeCtrl', [ '$controller', '$timeout', '$scope', '$rootScope', '$state', 'planSamplingService', 'alertService', 'dateUtilService',
		'securityService', 'urlSampleDetail', 'birtService', sampleAnalyzeCtrlFn ]);

function sampleAnalyzeCtrlFn($controller, $timeout, $scope, $rootScope, $state, planSamplingService, alertService, dateUtil, securityService, urlSampleDetail, birtService) {
    
	
	$scope.analysis = {
			type : []
	};
	// Hereda el controlador
	$controller('sampleHomeDetailBaseCtrl', {
		$timeout : $timeout,
		$scope : $scope,
		$rootScope : $rootScope,
		$state : $state,
		planSamplingService : planSamplingService,
		alertService : alertService,
		dateUtilService : dateUtil,
		securityService : securityService,
		urlSampleDetail : urlSampleDetail
	});

	$scope.export = function(){
		console.log("export");
		
		var dlnk = document.getElementById('linkExport');
		dlnk.href = birtService.workSheetAnalysis($scope.analysis.type.selected[0]);
		dlnk.click();
	}
	
}